import { gql } from '@apollo/client';

/**
 * Persist daily-ops services JSON on a WooCommerce order (order meta).
 * Bookings remain WooCommerce orders; services are manual itinerary rows.
 */
export const UPDATE_ORDER_OPS_SERVICES = gql`
  mutation UpdateOrderOpsServices($orderId: Int!, $metaData: [MetaDataInput]) {
    updateOrder(input: { orderId: $orderId, metaData: $metaData }) {
      order {
        databaseId
        metaData {
          key
          value
        }
      }
    }
  }
`;

export interface UpdateOrderOpsServicesData {
  updateOrder: {
    order: {
      databaseId: number;
      metaData?: Array<{ key: string; value: string }>;
    } | null;
  } | null;
}

export interface UpdateOrderOpsServicesVariables {
  orderId: number;
  metaData: Array<{ key: string; value: string }>;
}
